import { useNewTranslations } from '@/common/translations';
import { Jersey } from '@/ui/components';

import StatisticsNumber from '../StatisticsNumber';
import StatisticsLabel from '../StatisticsLabel';

interface TeamGoalsJerseyColumnProps {
  /** Displayed goal total for this side. */
  goalCount: number;
  /** Jersey image URL (same contract as `Jersey` `jerseySrc`). */
  jerseySrc: string;
  /** When true, column layout is mirrored for the away side. */
  isAway: boolean;
}

export default function TeamGoalsJerseyColumn({
  goalCount,
  jerseySrc,
  isAway,
}: TeamGoalsJerseyColumnProps) {
  const translate = useNewTranslations();

  return (
    <div
      className={`flex w-[80px] shrink-0 items-center justify-start gap-1${isAway ? ' flex-row-reverse' : ''}`}
    >
      <Jersey jerseySrc={jerseySrc} size={40} />
      <div className="flex min-h-px min-w-px flex-col gap-1">
        <StatisticsNumber>{goalCount}</StatisticsNumber>
        <StatisticsLabel>{translate('PreMatchStats.Goals')}</StatisticsLabel>
      </div>
    </div>
  );
}
